import { useNavigate } from "react-router-dom";

const withNavigation = (Component) => (props) => {
  const navigate = useNavigate();
  return <Component {...props} navigate={navigate} />;
};

export default withNavigation;
